export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "baronbet-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "baronbet-themeWrapLive" */'./LiveThemeImporter'),
  },
};
